import { IPersonalDetailsSteps } from "src/types";

const occupations: string[] = [
  'Private Sector',
  'Public Sector',
  'Government Service',
  'Business',
  'Professional',
  'Agriculturist',
  'Retired',
  'Housewife',
  'Student',
  'Others',
];

const incomeSlabs: string[] = [
  'Below Rs 1 Lac',
  '1-5 Lac',
  '5-10 Lac',
  '10-25 Lac',
  '>25 lac-1 cr',
  '>1 cr',
];

const tradingExperienceIntervals: string[] = [
  'Below 1 year',
  'Between 1 to 2 years',
  'Between 2 to 5 years',
  'More than 5 years',
];

const genders = [
  'Male',
  'Female',
  'Non binary',
];

const maritalStatus = [
  'Single',
  'Married',
];

const personalDetailsSteps : IPersonalDetailsSteps = [
  {
    id: 'gender',
    heading: 'Gender',
    description: 'Select one of the options',
    options: genders.map((item) => ({ option: item, value: item, label: item })),
    isEditable: true,
    inputType: 'select',
  },
  {
    id: 'maritalStatus',
    heading: 'Marital status',
    description: 'Select one of the options',
    options: maritalStatus.map((item) => ({ option: item, value: item, label: item })),
    isEditable: true,
    inputType: 'select',
  },
  {
    id: 'occupation',
    heading: 'Occupation',
    description: 'Which of these describes you the best?',
    options: occupations.map((item) => ({ option: item, value: item, label: item })),
    isEditable: true,
    inputType: 'select',
  },
  {
    id: 'incomeSegment',
    heading: 'What is your yearly income?',
    description: 'If you don’t know the exact amount, select a average or your best guess.',
    options: incomeSlabs.map((item) => ({ option: item, value: item, label: item })),
    isEditable: true,
    inputType: 'select',
  },
  {
    id: 'tradingExperience',
    heading: 'Trading experience',
    description: 'Select one of the options',
    options: tradingExperienceIntervals.map((item) => ({ option: item, value: item, label: item })),
    isEditable: true,
    inputType: 'select',
  },
  {
    id: 'fatherName',
    heading: 'Parent’s name',
    description: 'Important for completing your KYC.',
    options: [],
    isEditable: true,
    inputType: 'text',
  },
  {
    id: 'segmentSelection',
    heading: 'Select Segment',
    description: 'Select the segments you would like to activate.',
    options: [
      // {
      //   option: 'Equity',
      //   value: 'NSE_CM',
      // },
      {
        option: 'F&O',
        value: 'NSE_FO',
      },
    ],
    isEditable: false,
    inputType: 'select',
  },

];

export {
  occupations,
  incomeSlabs,
  tradingExperienceIntervals,
  genders,
  personalDetailsSteps,
}
